import { useQuery } from '@tanstack/react-query';
import getLivestreamType from 'Api/schedule-ruleset/getLivestreamType';
import getLivestreamTypeResponse from './model/response/getLivestreamTypeResponse';

const useGetLivestreamType = ({ enabled }) => {
  return useQuery({
    queryKey: ['ruleset-livestream-type'],
    queryFn: async () => {
      const response = await getLivestreamType();

      const result = getLivestreamTypeResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetLivestreamType;
